export default __webpack_public_path__ + "static/ue-loga-17107fab762a11a763e7afc3ad899dcc.svg";